import { Form } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrentLangPretty } from '../../../../helpers/url/urlHelpers';
import useCountries from '../../../../hooks/useCountries';
import usePostCodes from '../../../../hooks/usePostCodes';
import Button from '../../../base/button';
import { H4 } from '../../../base/typography';
import Error from '../../../error';
import { RawLoader } from '../../../loading/loading';
import ReceiverFields from './fields/receiverFields';
import SenderFields from './fields/senderFields';
import * as StyledStepInfoForm from './stepInfoForm.styles';

interface Props {
	values: any;
	errors: any;
	onPrevious: any;
	setFieldTouched: any;
	setFieldValue: any;
	isSubmitting: any;
	isValid: any;
}

const StepInfoForm: FC<Props> = ({ values, setFieldValue, setFieldTouched, onPrevious }) => {
	const { t } = useTranslation('registerShipment');
	const lang = getCurrentLangPretty();
	const { countries } = useCountries(lang, true);

	const { postCodes, postCodesLoading, postCodesError } = usePostCodes();
	if (postCodesLoading) return <RawLoader />;

	if (postCodesError) return <Error />;

	return (
		<Form>
			<H4 marginBottom="2rem">{t('shared.sender')}</H4>
			<SenderFields
				values={values}
				setFieldTouched={setFieldTouched}
				setFieldValue={setFieldValue}
				postcodes={postCodes}
				countries={countries}
			/>
			<H4 marginTop="4rem" marginBottom="2rem">
				{t('shared.recipient')}
			</H4>
			<ReceiverFields
				values={values}
				setFieldTouched={setFieldTouched}
				setFieldValue={setFieldValue}
				postcodes={postCodes}
				countries={countries}
			/>
			<StyledStepInfoForm.ButtonWrapper>
				<Button type="button" onClick={() => onPrevious(values)} wide>
					{t('shared.previous-step')}
				</Button>
				<Button wide primary type="submit">
					{t('shared.next-step')}
				</Button>
			</StyledStepInfoForm.ButtonWrapper>
		</Form>
	);
};

export default StepInfoForm;
